import { z } from "zod";

export const createAccountFormSchema = z
  .object({
    email: z.string().email("Please enter a valid email address"),
    username: z
      .string()
      .min(4, "Username must be at least 4 characters")
      .regex(/^[^\s]+$/, "Username cannot contain spaces"),
    password: z
      .string()
      .min(6, "Password must be at least 6 characters")
      .regex(/[A-Z]/, "Password must contain one uppercase letter")
      .regex(/[0-9]/, "Password must contain one number"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords must match.",
    path: ["confirmPassword"],
  });

export type CreateAccountFormSchema = z.infer<typeof createAccountFormSchema>;
